import {
  AttributeDisplayOptions,
  ControlWithChildrenProps,
} from "@plansoft-configuration-renderer/components";
import { CustomLayoutProps } from "@plansoft-configuration-renderer/layout";

export enum SelectControlAppearance {
  Select = "Select",
  Autocomplete = "Autocomplete",
}

export type SelectControlLayoutProps = AttributeDisplayOptions & {
  showEmptyOption: boolean;
  appearance: SelectControlAppearance;
};

export type SelectControlProps = ControlWithChildrenProps &
  Partial<SelectControlLayoutProps> &
  CustomLayoutProps;
